/* Font loading helpers shared by the Stickered builders.
   - stkFontIndexFetch: the font list is kept in localStorage for a day and
     returned instantly; a fresh copy is fetched in the background for next time.
   - stkLazyFont: a font-list tile gets its font as soon as it scrolls into view,
     and every listed font is also preloaded quietly in the background (16 at a
     time, in list order) a moment after the page loads, so the whole list is
     ready before it opens instead of filling in one by one. The preload is
     skipped on Data Saver / 2G, where tiles still load as they scroll in. */
(function(){
  if (window.stkFontIndexFetch) return;
  var KEY = 'stk-font-index-v1';
  var TTL = 24 * 60 * 60 * 1000;
  function fresh(url) {
    return fetch(url).then(function(res){
      if (!res.ok) return res;
      return res.clone().text().then(function(text){
        try { localStorage.setItem(KEY, JSON.stringify({ url: url, at: Date.now(), text: text })); } catch (e) {}
        return res;
      });
    });
  }
  window.stkFontIndexFetch = function(url) {
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (cached && cached.url === url && cached.text && Date.now() - cached.at < TTL) {
      fresh(url).catch(function(){});
      return Promise.resolve(new Response(cached.text, { status: 200, headers: { 'Content-Type': 'application/json' } }));
    }
    return fresh(url);
  };

  var queue = [], queued = {}, active = 0, LIMIT = 16, scheduled = false, warming = false;
  function slowConnection() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /2g/.test(c.effectiveType || '')));
  }
  function pump() {
    while (warming && active < LIMIT && queue.length) {
      active++;
      document.fonts.load('16px ' + queue.shift()).catch(function(){}).then(function(){ active--; pump(); });
    }
  }
  function scheduleWarm() {
    if (scheduled || slowConnection() || !document.fonts || !document.fonts.load) return;
    scheduled = true;
    var go = function(){
      setTimeout(function(){
        (window.requestIdleCallback || function(f){ f(); })(function(){ warming = true; pump(); }, { timeout: 3000 });
      }, 1000);
    };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      entry.target.style.fontFamily = entry.target.getAttribute('data-stk-lazy-font');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '150px' }) : null;
  window.stkLazyFont = function(el, family) {
    if (!queued[family]) { queued[family] = true; queue.push(family); scheduleWarm(); pump(); }
    if (!observer) { el.style.fontFamily = family; return; }
    el.setAttribute('data-stk-lazy-font', family);
    observer.observe(el);
  };
})();

(function(){
  if (window.__stickeredBannerBuilderGlobalReady) return;
  window.__stickeredBannerBuilderGlobalReady = true;

  var COLOURS = [
    { name: 'White', hex: '#ffffff' },
    { name: 'Black', hex: '#0a0a0a' },
    { name: 'Holographic Colour Shift', hex: '#ffffff', holo: true },
    { name: 'Yellow', hex: '#ffd400' },
    { name: 'Red', hex: '#e3001b' },
    { name: 'Orange', hex: '#ff6a00' },
    { name: 'Purple', hex: '#7b2cff' },
    { name: 'Pink', hex: '#ff3da6' },
    { name: 'Light Pink', hex: '#ffb6d5' },
    { name: 'Baby Blue', hex: '#7ec8ff' },
    { name: 'Sky Blue', hex: '#0074b8' },
    { name: 'Brilliant Blue', hex: '#1d24c2' },
    { name: 'Dark Blue', hex: '#0a1f5c' },
    { name: 'Mint', hex: '#9be8c4' },
    { name: 'Green', hex: '#1fa83c' },
    { name: 'Dark Green', hex: '#0b5d1e' },
    { name: 'Light Grey', hex: '#c8ccc7' },
    { name: 'Dark Grey', hex: '#868b8c' },
    { name: 'Chocolate Brown', hex: '#4b2514' },
    { name: 'Metallic Silver', hex: '#c8ccd1' },
    { name: 'Metallic Gold', hex: '#d4af37' },
    { name: 'Metallic Copper', hex: '#b87333' },
    { name: 'Matte Black', hex: '#1f1f1f' }
  ];

  function initStickeredBannerBuilder(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var section = root.closest('[id^="ProductSection-"]') || document;
    var organicTextSelector = [
      'input[name="properties[Text]"]:not([type="hidden"])',
      'textarea[name="properties[Text]"]',
      'input[name="properties[Your Text]"]:not([type="hidden"])',
      'textarea[name="properties[Your Text]"]'
    ].join(',');
    var organicInput = section.querySelector(organicTextSelector);
    var input = organicInput || root.querySelector('.stk-banner-input');
    var preview = root.querySelector('.stk-banner-preview-text');
    var fontButton = root.querySelector('.stk-banner-font-button');
    var fontLabel = root.querySelector('.stk-banner-font-label');
    var fontList = root.querySelector('.stk-banner-font-list');
    var fontName = root.querySelector('.stk-banner-font-name');
    var propText = root.querySelector('.stk-banner-prop-text');
    var propFont = root.querySelector('.stk-banner-prop-font');
    var qty = root.querySelector('.stk-banner-qty');

    if (!preview || !fontButton || !fontLabel || !fontList) return;

    var fontsBase = 'https://lzakvswydjwhynzrwold.supabase.co/storage/v1/object/public/fonts';
    var FALLBACK_FONTS = [{"name":"A4SPEED","file":"A4SPEED.ttf","format":"ttf"},{"name":"aAbsoluteEmpire","file":"aAbsoluteEmpire.otf","format":"otf"},{"name":"absender1","file":"absender1.ttf","format":"ttf"},{"name":"Aharoni","file":"Aharoni.ttf","format":"ttf"},{"name":"Airnt","file":"Airnt.otf","format":"otf"},{"name":"airstrike","file":"airstrike.ttf","format":"ttf"},{"name":"American Captain","file":"American Captain.otf","format":"otf"},{"name":"amsterdam","file":"amsterdam.ttf","format":"ttf"},{"name":"Ancient Medium","file":"Ancient Medium.ttf","format":"ttf"},{"name":"Avestrava","file":"Avestrava.ttf","format":"ttf"},{"name":"Batman Forever","file":"Batman Forever.ttf","format":"ttf"},{"name":"BeatMark","file":"BeatMark.ttf","format":"ttf"},{"name":"BebasNeue","file":"BebasNeue.ttf","format":"ttf"},{"name":"BillionDreams","file":"BillionDreams.ttf","format":"ttf"},{"name":"Birds of Paradise","file":"Birds_of_Paradise.ttf","format":"ttf"},{"name":"Black Devils","file":"Black Devils.ttf","format":"ttf"},{"name":"Black Mustang","file":"Black Mustang.ttf","format":"ttf"},{"name":"Blackiron","file":"Blackiron.ttf","format":"ttf"},{"name":"Blacksword","file":"Blacksword.otf","format":"otf"},{"name":"Bluetags","file":"Bluetags.otf","format":"otf"},{"name":"Brockers","file":"Brockers.ttf","format":"ttf"},{"name":"Brunson","file":"Brunson.ttf","format":"ttf"},{"name":"Built Titling","file":"Built_Titling.otf","format":"otf"},{"name":"Calling Heart","file":"Calling_Heart.ttf","format":"ttf"},{"name":"Chalk Walk","file":"Chalk Walk.otf","format":"otf"},{"name":"Champagne & Limousines","file":"Champagne & Limousines.ttf","format":"ttf"},{"name":"Chicago Athletic","file":"Chicago Athletic.ttf","format":"ttf"},{"name":"Chomsky","file":"Chomsky.otf","format":"otf"},{"name":"Chreed","file":"Chreed.ttf","format":"ttf"},{"name":"Coco Sharp Bold","file":"Coco-Sharp-Bold.ttf","format":"ttf"},{"name":"CODE","file":"CODE.otf","format":"otf"},{"name":"Comucan","file":"Comucan.otf","format":"otf"},{"name":"Coolvetica","file":"Coolvetica.otf","format":"otf"},{"name":"Cowboys 2.0","file":"Cowboys 2.0.otf","format":"otf"},{"name":"Cream Cake Bold","file":"Cream Cake Bold.otf","format":"otf"},{"name":"CryshGraffiti Regular","file":"CryshGraffiti-Regular.otf","format":"otf"},{"name":"Dash Horizon Demo","file":"Dash-Horizon-Demo.otf","format":"otf"},{"name":"Deadknight","file":"Deadknight.otf","format":"otf"},{"name":"Deartone","file":"Deartone.ttf","format":"ttf"},{"name":"Decaydence","file":"Decaydence.otf","format":"otf"},{"name":"Designer","file":"Designer.otf","format":"otf"},{"name":"Dragonlord","file":"Dragonlord.otf","format":"otf"},{"name":"Dream MMA","file":"Dream MMA.ttf","format":"ttf"},{"name":"Dunkerque","file":"Dunkerque.otf","format":"otf"},{"name":"Dunkerque Regular","file":"Dunkerque Regular.otf","format":"otf"},{"name":"Enchanted Land","file":"Enchanted Land.otf","format":"otf"},{"name":"Ethnocentric","file":"Ethnocentric.otf","format":"otf"},{"name":"Evogria","file":"Evogria.otf","format":"otf"},{"name":"False","file":"False.ttf","format":"ttf"},{"name":"FankyBubbleGraffiti Regular","file":"FankyBubbleGraffiti-Regular.otf","format":"otf"},{"name":"FLASTY Trial","file":"FLASTY Trial.otf","format":"otf"},{"name":"Freshman","file":"Freshman.ttf","format":"ttf"},{"name":"freshmarker","file":"freshmarker.ttf","format":"ttf"},{"name":"Gameplay","file":"Gameplay.ttf","format":"ttf"},{"name":"Golden Varsity Outline","file":"Golden Varsity Outline.ttf","format":"ttf"},{"name":"GraffitiSkater","file":"GraffitiSkater.otf","format":"otf"},{"name":"GraffitiYouth","file":"GraffitiYouth.otf","format":"otf"},{"name":"GraffitiYouth Regular","file":"GraffitiYouth-Regular.otf","format":"otf"},{"name":"GrimeSlime","file":"GrimeSlime.ttf","format":"ttf"},{"name":"GunerGraffiti Regular","file":"GunerGraffiti-Regular.otf","format":"otf"},{"name":"Harabara","file":"Harabara.otf","format":"otf"},{"name":"Hello Valentina","file":"Hello Valentina.ttf","format":"ttf"},{"name":"Impact","file":"Impact.ttf","format":"ttf"},{"name":"Infinite Stroke","file":"Infinite Stroke.otf","format":"otf"},{"name":"Jamstreet Graffiti","file":"Jamstreet Graffiti.ttf","format":"ttf"},{"name":"Jump Streets Regular","file":"Jump Streets Regular.ttf","format":"ttf"},{"name":"Jumper Bold","file":"Jumper-Bold.ttf","format":"ttf"},{"name":"KOMIKAX","file":"KOMIKAX.ttf","format":"ttf"},{"name":"LEMONMILK Bold","file":"LEMONMILK-Bold.otf","format":"otf"},{"name":"Licenz","file":"Licenz.ttf","format":"ttf"},{"name":"Long Shot","file":"Long_Shot.ttf","format":"ttf"},{"name":"MADE Tommy Soft Medium","file":"MADE Tommy Soft Medium.otf","format":"otf"},{"name":"Madison Street","file":"Madison Street.ttf","format":"ttf"},{"name":"Maloney","file":"Maloney.otf","format":"otf"},{"name":"Maximum Voltage","file":"Maximum Voltage.otf","format":"otf"},{"name":"Metal Lord","file":"Metal Lord.otf","format":"otf"},{"name":"Michland Script","file":"Michland_Script.otf","format":"otf"},{"name":"Michroma","file":"Michroma.ttf","format":"ttf"},{"name":"MinecraftFifty Solid","file":"MinecraftFifty-Solid.otf","format":"otf"},{"name":"Mostwasted","file":"Mostwasted.ttf","format":"ttf"},{"name":"Nau Sea","file":"Nau Sea.otf","format":"otf"},{"name":"Nexa Heavy","file":"Nexa-Heavy.ttf","format":"ttf"},{"name":"Nulshock","file":"Nulshock.otf","format":"otf"},{"name":"OldLondon","file":"OldLondon.ttf","format":"ttf"},{"name":"One Slice","file":"One Slice.otf","format":"otf"},{"name":"Orittish","file":"Orittish.otf","format":"otf"},{"name":"Paladins","file":"Paladins.ttf","format":"ttf"},{"name":"PERFORMANCE","file":"PERFORMANCE.otf","format":"otf"},{"name":"PhillySans","file":"PhillySans.otf","format":"otf"},{"name":"PicturamaFounder","file":"PicturamaFounder.otf","format":"otf"},{"name":"PoetsenOne","file":"PoetsenOne.ttf","format":"ttf"},{"name":"Pointless","file":"Pointless.ttf","format":"ttf"},{"name":"Provicali","file":"Provicali.otf","format":"otf"},{"name":"Quadrillion","file":"Quadrillion.otf","format":"otf"},{"name":"Quicksilver","file":"Quicksilver.otf","format":"otf"},{"name":"Race Sport","file":"Race_Sport.ttf","format":"ttf"},{"name":"Readfine","file":"Readfine.ttf","format":"ttf"},{"name":"Readfine Demo","file":"Readfine Demo.ttf","format":"ttf"},{"name":"Sacred Hertz","file":"Sacred Hertz.otf","format":"otf"},{"name":"Sanseriffic","file":"Sanseriffic.otf","format":"otf"},{"name":"Sephora & Hayden","file":"Sephora & Hayden.ttf","format":"ttf"},{"name":"Skilled Hands","file":"Skilled Hands.otf","format":"otf"},{"name":"Street Breaker","file":"Street Breaker.otf","format":"otf"},{"name":"Street Threat","file":"Street Threat.otf","format":"otf"},{"name":"Summer Dream Sans","file":"Summer Dream Sans.ttf","format":"ttf"},{"name":"Sunday Midnight","file":"Sunday Midnight.otf","format":"otf"},{"name":"Sunshine","file":"Sunshine.ttf","format":"ttf"},{"name":"Tempting","file":"Tempting.otf","format":"otf"},{"name":"The Augusta","file":"The_Augusta.otf","format":"otf"},{"name":"The Sunset","file":"The-Sunset.ttf","format":"ttf"},{"name":"Uniwars","file":"Uniwars.otf","format":"otf"},{"name":"Urban Heroes","file":"Urban Heroes.ttf","format":"ttf"},{"name":"Urban Hustle","file":"Urban Hustle.ttf","format":"ttf"},{"name":"Urban Shadow Sans Serif","file":"Urban Shadow Sans Serif.otf","format":"otf"},{"name":"Urban Shadow Script","file":"Urban Shadow Script.otf","format":"otf"},{"name":"Utendo Bold","file":"Utendo-Bold.ttf","format":"ttf"},{"name":"Utendo Regular","file":"Utendo-Regular.ttf","format":"ttf"},{"name":"Vampire Wars","file":"Vampire_Wars.otf","format":"otf"},{"name":"varsity regular","file":"varsity_regular.ttf","format":"ttf"},{"name":"Venus Rising","file":"Venus Rising.otf","format":"otf"},{"name":"Walkway","file":"Walkway.ttf","format":"ttf"},{"name":"Wanted M54","file":"Wanted M54.ttf","format":"ttf"},{"name":"White Smith","file":"White Smith.otf","format":"otf"},{"name":"whoa!","file":"whoa!.ttf","format":"ttf"},{"name":"Wreckside","file":"Wreckside.otf","format":"otf"}];
    var fontsIndexUrl = 'https://flow.stickered.co.nz/api/public/fonts';
    var currentFont = { name: 'Default', css: 'Arial, sans-serif' };
    var previewColour = { name: 'Black', hex: '#0a0a0a' };

    function findOrganicTextInput() {
      var byName = section.querySelector(organicTextSelector);
      if (byName) return byName;

      // Easify's text-field option no longer renders a name/id attribute we can
      // select on, so fall back to matching its component class + label text.
      var candidates = section.querySelectorAll('.po-textField-input, [class*="po-textField-input"]');
      var fallback = null;
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        var fieldRoot = el.closest('[class*="po-field-root"]');
        var labelEl = fieldRoot && fieldRoot.querySelector('[class*="po-label-root"]');
        var labelText = labelEl ? labelEl.textContent : '';
        if (!fallback) fallback = el;
        if (labelText && /text/i.test(labelText)) return el;
      }
      return fallback;
    }

    function getInput() {
      return findOrganicTextInput() || input;
    }

    function ensureHiddenProperty(className, propertyName) {
      var field = root.querySelector('.' + className);
      var isNew = !field;

      if (isNew) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.className = className;
        field.name = 'properties[' + propertyName + ']';
      }

      var formId = root.getAttribute('data-product-form') || (section.querySelector('form[action*="/cart/add"]') || {}).id;
      if (formId) field.setAttribute('form', formId);

      if (isNew) root.appendChild(field);
      return field;
    }

    propText = ensureHiddenProperty('stk-banner-prop-text', 'Text');
    propFont = ensureHiddenProperty('stk-banner-prop-font', 'Font');

    function bindTextInput(nextInput) {
      if (!nextInput || nextInput === input) return;
      input = nextInput;
      if (input.dataset.stkBannerBound !== 'true') {
        input.dataset.stkBannerBound = 'true';
        input.addEventListener('input', update);
        input.addEventListener('change', update);
      }
      update();
    }

    function getPreviewValue() {
      var activeInput = getInput();
      return activeInput && activeInput.value ? activeInput.value : 'Custom Text';
    }

    function setFontPreviewContent(target, value, fontName) {
      if (!target) return;
      target.textContent = '';

      var sample = document.createElement('span');
      sample.className = 'stk-banner-font-sample';
      sample.textContent = value;

      var name = document.createElement('span');
      name.className = 'stk-banner-font-option-name';
      name.textContent = ' (' + fontName + ')';
      name.style.fontFamily = 'Arial, sans-serif';
      name.style.fontSize = '10px';
      name.style.fontWeight = '700';
      name.style.letterSpacing = '.04em';
      name.style.color = '#777';
      name.style.verticalAlign = 'middle';
      name.style.textTransform = 'uppercase';

      target.appendChild(sample);
      target.appendChild(name);
    }

    function refreshFontOptionLabels() {
      var value = getPreviewValue();
      Array.prototype.forEach.call(fontList.children, function(item){
        setFontPreviewContent(item, value, item.getAttribute('data-name') || 'Default');
        item.setAttribute('title', item.getAttribute('data-name') || value);
      });
    }

    function compactEasifySpacing() {
      var customContainer = root.closest('.tpo_option-container, [class*="tpo_option-container"]');
      if (!customContainer) return;

      customContainer.style.setProperty('margin-bottom', '0', 'important');
      customContainer.style.setProperty('padding-bottom', '0', 'important');

      var next = customContainer.nextElementSibling;
      while (next && !/tpo_option-container/.test(next.className || '')) {
        next = next.nextElementSibling;
      }
      if (next) {
        next.style.setProperty('margin-top', '-8px', 'important');
        next.style.setProperty('padding-top', '0', 'important');
      }
    }

    function moveTextFieldBeforeFont() {
      var organicTextInput = findOrganicTextInput();
      var fallbackField = root.querySelector('.stk-banner-field--fallback-text');
      var textContainer = organicTextInput && organicTextInput.closest('.tpo_option-container, [class*="tpo_option-container"]');
      var fontField = root.querySelector('.stk-banner-field--font');

      if (organicTextInput && fallbackField) {
        fallbackField.style.setProperty('display', 'none', 'important');
        if (propText) propText.disabled = true;
      } else if (fallbackField) {
        fallbackField.style.removeProperty('display');
        if (propText) propText.disabled = false;
      }

      if (!organicTextInput || !textContainer || !fontField || textContainer.contains(root)) return;

      if (textContainer.parentNode !== root || textContainer.nextElementSibling !== fontField) {
        root.insertBefore(textContainer, fontField);
      }

      textContainer.style.setProperty('margin-top', '14px', 'important');
      textContainer.style.setProperty('margin-bottom', '0', 'important');
      textContainer.style.setProperty('padding-top', '0', 'important');
      textContainer.style.setProperty('padding-bottom', '0', 'important');
      fontField.style.setProperty('margin-top', '14px', 'important');
      fontField.style.setProperty('margin-bottom', '0', 'important');
      compactEasifySpacing();
    }

    function normalise(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    function colourFromText(value) {
      var key = normalise(value);
      if (!key) return null;

      for (var i = 0; i < COLOURS.length; i++) {
        var colour = COLOURS[i];
        var colourKey = normalise(colour.name);
        if (key === colourKey || key.indexOf(colourKey) !== -1 || colourKey.indexOf(key) !== -1) return colour;
      }

      if (key.indexOf('holo') !== -1) return COLOURS.filter(function(c){ return c.holo; })[0] || null;
      if (key.indexOf('matteblack') !== -1) return COLOURS.filter(function(c){ return c.name === 'Matte Black'; })[0] || null;
      if (key.indexOf('silver') !== -1) return COLOURS.filter(function(c){ return c.name === 'Metallic Silver'; })[0] || null;
      if (key.indexOf('gold') !== -1) return COLOURS.filter(function(c){ return c.name === 'Metallic Gold'; })[0] || null;
      if (key.indexOf('copper') !== -1) return COLOURS.filter(function(c){ return c.name === 'Metallic Copper'; })[0] || null;
      return null;
    }

    function rgbToHex(value) {
      var match = String(value || '').match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!match) return '';
      return '#' + [match[1], match[2], match[3]].map(function(part){
        var hex = Math.max(0, Math.min(255, parseInt(part, 10))).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      }).join('');
    }

    function colourFromComputed(target) {
      if (!target) return null;
      var style = getComputedStyle(target);
      var candidates = [
        target.getAttribute('aria-label'),
        target.getAttribute('title'),
        target.getAttribute('alt'),
        target.getAttribute('data-value'),
        target.value,
        target.src,
        style.backgroundImage,
        style.backgroundColor
      ];

      for (var i = 0; i < candidates.length; i++) {
        var byText = colourFromText(candidates[i]);
        if (byText) return byText;
      }

      var bgHex = rgbToHex(style.backgroundColor);
      if (bgHex) {
        for (var j = 0; j < COLOURS.length; j++) {
          if ((COLOURS[j].hex || '').toLowerCase() === bgHex.toLowerCase()) return COLOURS[j];
        }
      }

      return null;
    }

    function looksSelected(element) {
      var node = element;
      for (var depth = 0; node && depth < 8; depth++, node = node.parentElement) {
        var cls = String(node.className || '').toLowerCase();
        if (/(selected|is-selected|active|checked)/.test(cls)) return true;
        if (node.getAttribute && (node.getAttribute('aria-checked') === 'true' || node.getAttribute('aria-selected') === 'true')) return true;
        var checked = node.querySelector && node.querySelector('input:checked');
        if (checked) return true;

        var style = getComputedStyle(node);
        var visual = [style.borderColor, style.outlineColor, style.boxShadow].join(' ').toLowerCase();
        if (
          visual.indexOf('125, 0, 220') !== -1 ||
          visual.indexOf('124, 58, 237') !== -1 ||
          visual.indexOf('137, 0, 255') !== -1 ||
          visual.indexOf('#7d00dc') !== -1
        ) return true;
      }
      return false;
    }

    function findNativeColourSelection() {
      var customContainer = root.closest('.tpo_option-container, [class*="tpo_option-container"]');
      var containers = Array.prototype.slice.call(section.querySelectorAll('.tpo_option-container, [class*="tpo_option-container"]'))
        .filter(function(container){
          if (!container || root.contains(container) || container === customContainer) return false;
          var text = (container.textContent || '').toLowerCase();
          return text.indexOf('colour') !== -1 || text.indexOf('color') !== -1;
        });

      for (var i = 0; i < containers.length; i++) {
        var options = containers[i].querySelectorAll('img, button, label, [role="radio"], [aria-checked], input');
        for (var j = 0; j < options.length; j++) {
          if (!looksSelected(options[j])) continue;
          var colour = colourFromComputed(options[j]) || colourFromComputed(options[j].closest('label, button, [role="radio"], div'));
          if (colour) return colour;
        }
      }

      return null;
    }

    function applyColourToPreview() {
      preview.style.backgroundImage = '';
      preview.style.backgroundSize = '';
      preview.style.webkitBackgroundClip = '';
      preview.style.backgroundClip = '';
      preview.style.webkitTextFillColor = '';
      preview.style.filter = '';

      if (previewColour && previewColour.holo) {
        preview.style.color = '#0a0a0a';
        preview.style.backgroundImage = 'repeating-linear-gradient(125deg,rgba(255,255,255,.78) 0 3px,rgba(255,255,255,0) 3px 13px),linear-gradient(100deg,#00d5ff 0%,#7c3aed 16%,#ff4fc3 31%,#fff176 48%,#38f8b6 64%,#60a5fa 80%,#f0abfc 100%)';
        preview.style.backgroundSize = '42px 42px, 240% 100%';
        preview.style.webkitBackgroundClip = 'text';
        preview.style.backgroundClip = 'text';
        preview.style.webkitTextFillColor = 'transparent';
        preview.style.filter = 'saturate(1.18) contrast(1.04)';
        return;
      }

      var lightColours = {
        '#ffffff': true,
        '#ffd400': true,
        '#ffb6d5': true,
        '#7ec8ff': true,
        '#9be8c4': true,
        '#c8ccc7': true,
        '#c8ccd1': true,
        '#d4af37': true
      };
      var hex = (previewColour.hex || '#0a0a0a').toLowerCase();
      preview.style.color = lightColours[hex] ? '#0a0a0a' : previewColour.hex;
    }

    function update() {
      var activeInput = getInput();
      var value = getPreviewValue();
      previewColour = { name: 'Black', hex: '#0a0a0a' };

      preview.textContent = value;
      preview.style.fontFamily = currentFont.css;
      applyColourToPreview();

      if (activeInput && activeInput.classList.contains('stk-banner-input')) {
        activeInput.style.fontFamily = currentFont.css;
      }

      setFontPreviewContent(fontLabel, value, currentFont.name);
      fontLabel.style.fontFamily = currentFont.css;

      if (fontName) fontName.textContent = currentFont.name !== 'Default' ? '(' + currentFont.name + ')' : '';
      if (propText && activeInput && activeInput !== propText && !propText.disabled) propText.value = activeInput.value;
      if (propFont) propFont.value = currentFont.name;

      refreshFontOptionLabels();
      compactEasifySpacing();
      moveTextFieldBeforeFont();

      var warning = root.querySelector('.stk-banner-number-warning');
      if (warning) {
        var hasNumber = /\d/.test((activeInput && activeInput.value) || '');
        warning.hidden = !hasNumber;
        warning.setAttribute('aria-hidden', hasNumber ? 'false' : 'true');
        warning.style.display = hasNumber ? 'flex' : 'none';
      }

      var baseFontSize = 48;
      preview.style.fontSize = baseFontSize + 'px';
      requestAnimationFrame(function(){
        var box = preview.parentNode;
        if (!box) return;
        var styles = getComputedStyle(box);
        var available = box.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
        var width = preview.scrollWidth;
        if (width > available && width > 0) {
          preview.style.fontSize = Math.max(14, Math.floor(baseFontSize * (available / width))) + 'px';
        }
      });
    }

    function buildFonts(fonts) {
      var oldStyle = document.getElementById('stk-banner-custom-font-faces');
      if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);

      var styleEl = document.createElement('style');
      styleEl.id = 'stk-banner-custom-font-faces';
      fontList.innerHTML = '';

      if (!Array.isArray(fonts) || !fonts.length) {
        currentFont = { name: 'Default', css: 'Arial, sans-serif' };
        fontLabel.textContent = 'Default';
        update();
        return;
      }

      fonts.forEach(function(font, index){
        var family = 'stk-banner-font-' + index;
        var formatMap = { ttf: 'truetype', otf: 'opentype', woff: 'woff', woff2: 'woff2' };
        var rawFormat = (font.format || 'truetype').toLowerCase();
        var format = formatMap[rawFormat] || rawFormat;
        var url = font.url || fontsBase + '/' + encodeURIComponent(String(font.file).normalize('NFKD').replace(/[^A-Za-z0-9._-]+/g, '_'));

        styleEl.appendChild(document.createTextNode(
          "@font-face{font-family:'" + family + "';src:url('" + url + "') format('" + format + "');font-display:swap;}"
        ));

        var item = document.createElement('li');
        item.setAttribute('role', 'option');
        item.setAttribute('data-name', font.name);
        item.setAttribute('data-css', "'" + family + "', sans-serif");
        setFontPreviewContent(item, getPreviewValue(), font.name);
        item.setAttribute('title', font.name);
        window.stkLazyFont(item, "'" + family + "', sans-serif");
        fontList.appendChild(item);
      });

      document.head.appendChild(styleEl);

      var first = fontList.querySelector('li');
      if (first) {
        first.setAttribute('aria-selected', 'true');
        currentFont = {
          name: first.getAttribute('data-name'),
          css: first.getAttribute('data-css')
        };
      }

      update();
    }

    fontButton.addEventListener('click', function(){
      refreshFontOptionLabels();
      fontList.hidden = !fontList.hidden;
      fontButton.setAttribute('aria-expanded', fontList.hidden ? 'false' : 'true');
    });

    fontList.addEventListener('click', function(event){
      var item = event.target.closest('li');
      if (!item) return;

      Array.prototype.forEach.call(fontList.children, function(child){
        child.removeAttribute('aria-selected');
      });

      item.setAttribute('aria-selected', 'true');
      currentFont = {
        name: item.getAttribute('data-name'),
        css: item.getAttribute('data-css')
      };

      fontList.hidden = true;
      fontButton.setAttribute('aria-expanded', 'false');
      update();
    });

    document.addEventListener('click', function(event){
      if (!root.contains(event.target)) {
        fontList.hidden = true;
        fontButton.setAttribute('aria-expanded', 'false');
      }
    });

    root.querySelectorAll('[data-stk-banner-qty]').forEach(function(button){
      button.addEventListener('click', function(){
        if (!qty) return;
        var step = parseInt(button.getAttribute('data-stk-banner-qty'), 10) || 1;
        var value = Math.max(1, (parseInt(qty.value, 10) || 1) + step);
        qty.value = value;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (input) input.addEventListener('input', update);
    section.addEventListener('input', function(event){
      if (event.target && event.target.matches(organicTextSelector)) {
        bindTextInput(event.target);
      }
    }, true);
    section.addEventListener('change', function(event){
      if (event.target && event.target.matches(organicTextSelector)) {
        bindTextInput(event.target);
      }
    }, true);
    section.addEventListener('click', function(event){
      if (event.target && event.target.closest('.tpo_option-container, [class*="tpo_option-container"]')) {
        setTimeout(update, 40);
        setTimeout(update, 180);
      }
    }, true);
    section.addEventListener('change', function(event){
      var container = event.target && event.target.closest && event.target.closest('.tpo_option-container, [class*="tpo_option-container"]');
      if (container && /colou?r/i.test(container.textContent || '')) {
        setTimeout(update, 40);
      }
    }, true);
    window.addEventListener('resize', update);

    setTimeout(function(){ bindTextInput(findOrganicTextInput()); compactEasifySpacing(); moveTextFieldBeforeFont(); }, 250);
    setTimeout(function(){ bindTextInput(findOrganicTextInput()); compactEasifySpacing(); moveTextFieldBeforeFont(); }, 1000);
    setTimeout(function(){ bindTextInput(findOrganicTextInput()); compactEasifySpacing(); moveTextFieldBeforeFont(); }, 2500);

    window.stkFontIndexFetch(fontsIndexUrl)
      .then(function(response){ return response.ok ? response.json() : FALLBACK_FONTS; })
      .then(function(fonts){ buildFonts(Array.isArray(fonts) && fonts.length ? fonts : FALLBACK_FONTS); })
      .catch(function(){ buildFonts(FALLBACK_FONTS); });

    update();
  }

  function initAllStickeredBannerBuilders() {
    document.querySelectorAll('[data-stk-banner-builder]').forEach(initStickeredBannerBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStickeredBannerBuilders);
  } else {
    initAllStickeredBannerBuilders();
  }

  if (window.MutationObserver) {
    var queued = false;
    var observer = new MutationObserver(function(){
      if (queued) return;
      queued = true;
      setTimeout(function(){
        queued = false;
        initAllStickeredBannerBuilders();
      }, 100);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function(){ observer.disconnect(); }, 30000);
  }
})();
